import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { PromoState, StateWithPromo } from '../promo-state';
import { getFeatureState } from './feature.selector';

export const getEmailSubscriptionState: MemoizedSelector<StateWithPromo, PromoState['emailSubscription']> =
  createSelector(
    getFeatureState,
    (state: PromoState | undefined) => state?.emailSubscription ?? StateUtils.initialLoaderState,
  );

export const getEmailSubscriptionLoading: MemoizedSelector<StateWithPromo, boolean> = createSelector(
  getEmailSubscriptionState,
  (state) => StateUtils.loaderLoadingSelector(state),
);

export const getEmailSubscriptionError: MemoizedSelector<StateWithPromo, boolean> = createSelector(
  getEmailSubscriptionState,
  (state) => StateUtils.loaderErrorSelector(state),
);

export const getEmailSubscriptionSuccess: MemoizedSelector<StateWithPromo, boolean> = createSelector(
  getEmailSubscriptionState,
  (state) => StateUtils.loaderSuccessSelector(state),
);

export const getEmailSubscriptionValue: MemoizedSelector<StateWithPromo, boolean> = createSelector(
  getEmailSubscriptionState,
  (state) => StateUtils.loaderValueSelector(state),
);
